import Vue from 'vue'

const mutations = {
    changeChatWindowStatus(state, payload) {
        state.chatWindowStatus = payload;
    },
    actionMessage(state, payload) {
        state.messages.push({
            sender: payload.sender,
            created_at: new Date(),
            text: payload.text
        });
    },
    changeWaitingList(state, payload) {
        state.waitingList = payload
    },
    emptyChatWindow(state) {
        //state.messages = [];
    },
    changeWritting(state, value, role) {
        state[role].isWritting = value;
    },
    setLastId(state,value) {
        state.lastId = value;
    },
    addMessages(state,messages) {

        if (messages.length>0){

            for (var idx in messages){

                if (!state.printedMessages[messages[idx].message_id]) {
                    state.hasNewMessages = true;
                    state.messages = state.messages.concat(messages[idx]);
                    state.printedMessages[messages[idx].message_id] = true;
                }

            }

            //state.messages = state.messages.concat(messages);

        }

    },
    setId(state,id) {

        state.id = id;

    },
    setToken(state,token) {

        state.token = token;

    },
    setLanguage(state,language) {
        state.language = language;
    },
    setClient(state, client){
        if(client){
            state.user.name = client.name;
            state.user.email = client.email;
        }
    },
    clearClient (state){
        state.user.name = null;
        state.user.email = null;
    },
    setCartInfo(state, cart_info){
        if(cart_info){
            state.cartInfo.token = cart_info.token;
            state.cartInfo.share_url = cart_info.share_url;
            state.cartInfo.quantity_items = cart_info.quantity_items;
        }
    },
    clearCartInfo (state){
        //{"token":"13PS4TC8XJYYO0gSDOUY","share_url":"http:\/\/islas4dev-es.deswebislas.com:8080\/mallorca\/en\/ChatCart\/13PS4TC8XJYYO0gSDOUY","quantity_items":3}
        state.cartInfo.token = null;
        state.cartInfo.share_url = null;
        state.cartInfo.quantity_items = 0;
    },
    setAgent(state, agent){
        if(agent){
            state.agent.name = agent.name;
            state.agent.avatar = agent.avatar;
        }
    },
    setChatTypes(state, payload){
        if(payload){
            state.chatTypes = payload;
            state.chatType = 0;
        }
    },
    closeChat(state) {
        state.id = null;
        state.token = null;
        state.lastId = 0;
        state.messages = [];
        state.printedMessages = {};
        state.hasNewMessages = false;
    },
    setLocale(state, lang){
        state.language = lang;
        Vue.config.language = document.documentElement.lang;
    },
    setPolicyUrl(state, url){
        state.policy_url = url;
    },
    setThreadState(state, thread_state){
        state.thread_state = thread_state;
    },
    changeBounce(state, value){
        state.bounce = value
    },
    messagesSeen(state){
        state.hasNewMessages = false;
    },
    changeHasBounced(state, value){
        state.hasBounced = value;
    },
    setChatOpen(state, value){
        state.isChatOpened = value
    }
};

export default mutations